import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#F9FAF7] text-[#2E2E2E]">
      <header className="border-b border-[#DCE5DB]/70 bg-white/70 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <div className="w-9 h-9 rounded-2xl bg-[#4F6F52] flex items-center justify-center shadow-[0_4px_14px_rgba(79,111,82,0.25)]">
              <Sparkles size={16} className="text-[#F9FAF7]" strokeWidth={1.8} />
            </div>
            <span className="font-display text-xl text-[#4F6F52]">LifeGuide</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-[#6B6B6B] hover:text-[#4F6F52] inline-flex items-center gap-1.5"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} strokeWidth={1.8} /> Back
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-display text-3xl sm:text-4xl text-[#2E2E2E] mb-2">{title}</h1>
        <p className="text-sm text-[#6B6B6B] mb-10">Last updated: {updated}</p>
        <article className="legal-prose space-y-6 leading-relaxed text-[15px] text-[#2E2E2E]">
          {children}
        </article>
        <div className="mt-14 pt-6 border-t border-[#DCE5DB] text-sm text-[#6B6B6B] flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/privacy" className="hover:text-[#4F6F52]" data-testid="legal-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-[#4F6F52]" data-testid="legal-terms-link">
            Terms of Service
          </Link>
          <Link to="/sms" className="hover:text-[#4F6F52]" data-testid="legal-sms-link">
            SMS Updates
          </Link>
          <Link to="/contact" className="hover:text-[#4F6F52]" data-testid="legal-contact-link">
            Contact
          </Link>
        </div>
      </main>
    </div>
  );
}

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl text-[#2E2E2E] mb-2.5 mt-4">{heading}</h2>
    <div className="space-y-3 text-[#3B3B3B]">{children}</div>
  </section>
);
